import { render, staticRenderFns } from "./SpeakersContainer.vue?vue&type=template&id=6b0c2f5b&scoped=true&"
import script from "./SpeakersContainer.vue?vue&type=script&lang=js&"
export * from "./SpeakersContainer.vue?vue&type=script&lang=js&"
import style0 from "./SpeakersContainer.vue?vue&type=style&index=0&id=6b0c2f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c2f5b",
  null
  
)

component.options.__file = "SpeakersContainer.vue"
export default component.exports